import { combineReducersWithRoot, createReducer } from '@common/redux-utils';
import { CILNotificationViewModel } from '@services/CILNotificationService';

import {
  CILNotificationActionType,
  GetCILNotificationFailureAction,
  GetCILNotificationStartAction,
  GetCILNotificationSuccessAction,
  GetCILNotificationWarnAction,
  GotoPageAction,
  SubmitSelectionFailureAction,
  SubmitSelectionStartAction,
  SubmitSelectionSuccessAction
} from './cil-notification.actions';
import { cilNotificationCILInitialState, CILNotificationCILReducer, CILNotificationCILState } from './_components/cil';
import {
  cilNotificationReplacementInitialState,
  CILNotificationReplacementReducer,
  CILNotificationReplacementState
} from './_components/replacement';
import { CILNotificationComponentPage } from './_components/cil-notification.component';

// Defining the state of the page.
// Should be one per page.
// All properties should be readonly.
export interface CILNotificationState {
  cil: CILNotificationCILState;
  contractId?: number;
  isLoading: boolean;
  page: CILNotificationComponentPage;
  replacement: CILNotificationReplacementState;
  swoTrackingCILOfferId?: number;
  token?: string;
  viewModel?: CILNotificationViewModel;
  warningMessage?: string;
}

// This is the initial state of the page
const initialState: CILNotificationState = {
  cil: cilNotificationCILInitialState,
  isLoading: true,
  page: CILNotificationComponentPage.Landing,
  replacement: cilNotificationReplacementInitialState
};

function handleGetCILNotificationFailure(
  state: CILNotificationState,
  action: GetCILNotificationFailureAction
): CILNotificationState {
  return {
    ...state,
    isLoading: false
  };
}

function handleGetCILNotificationStart(
  state: CILNotificationState,
  action: GetCILNotificationStartAction
): CILNotificationState {
  return {
    ...state,
    contractId: action.contractId,
    isLoading: true,
    swoTrackingCILOfferId: action.swoTrackingCILOfferId,
    token: action.token
  };
}

function handleGetCILNotificationSuccess(
  state: CILNotificationState,
  action: GetCILNotificationSuccessAction
): CILNotificationState {
  return {
    ...state,
    isLoading: false,
    viewModel: action.viewModel
  };
}

function handleGetCILNotificationWarn(
  state: CILNotificationState,
  action: GetCILNotificationWarnAction
): CILNotificationState {
  return {
    ...state,
    isLoading: false,
    warningMessage: action.message
  };
}

function handleGotoPage(state: CILNotificationState, action: GotoPageAction): CILNotificationState {
  return {
    ...state,
    page: action.page
  };
}

function handleSubmitSelectionFailure(
  state: CILNotificationState,
  action: SubmitSelectionFailureAction
): CILNotificationState {
  return {
    ...state,
    isLoading: false,
    page: CILNotificationComponentPage.ConfirmationError
  };
}

function handleSubmitSelectionSuccess(
  state: CILNotificationState,
  action: SubmitSelectionSuccessAction
): CILNotificationState {
  return {
    ...state,
    isLoading: false,
    page: CILNotificationComponentPage.Confirmation
  };
}

function handleSubmitSelectionStart(
  state: CILNotificationState,
  action: SubmitSelectionStartAction
): CILNotificationState {
  return {
    ...state,
    isLoading: true
  };
}

// This creates the reducer as redux wants it w/ a helper function
// There should an entry for each action type
const reducer = createReducer(initialState, {
  [CILNotificationActionType.GetCILNotificationFailure]: handleGetCILNotificationFailure,
  [CILNotificationActionType.GetCILNotificationStart]: handleGetCILNotificationStart,
  [CILNotificationActionType.GetCILNotificationSuccess]: handleGetCILNotificationSuccess,
  [CILNotificationActionType.GetCILNotificationWarn]: handleGetCILNotificationWarn,
  [CILNotificationActionType.GotoPage]: handleGotoPage,
  [CILNotificationActionType.SubmitSelectionFailure]: handleSubmitSelectionFailure,
  [CILNotificationActionType.SubmitSelectionSuccess]: handleSubmitSelectionSuccess,
  [CILNotificationActionType.SubmitSelectionStart]: handleSubmitSelectionStart
});

export const CILNotificationReducer = combineReducersWithRoot(reducer, {
  cil: CILNotificationCILReducer,
  replacement: CILNotificationReplacementReducer
});



// WEBPACK FOOTER //
// ./src/cil-notification/cil-notification.reducer.ts